export default __webpack_public_path__ + "static/media/Pending2.e6e6695a.svg";